module.exports = __webpack_public_path__ + "img/icb-del-Inte-e@2x.45750a46.png";